import { useMutation } from "@tanstack/react-query";
import { videoUpdate } from "common/api/sakusas/sakusas_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constant/react_query";

type UseSakusasVideoUpdateParams = {
  invalidateKeys?: string[];
};

export const useSakusasVideoUpdate = (
  hookParams?: UseSakusasVideoUpdateParams
) => {
  const queryClient = useQueryClient();
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await videoUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.SAKUSAS_VIDEO_GET],
        });
      }
    },
  });

  return { videoUpdateMutate };
};
